import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Globals } from "@foh/globals";
import { Router, ActivatedRoute } from "@angular/router";
import { ReservationformService } from "../reservationform/reservationform.service";
import { CustomerauthService } from "@foh/shared/auth/customerauth.service";
import * as alertFunctions from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray
} from "@angular/forms";
import {
  emailValidator,
  phoneValidator,
  nameValidator,
  matchingPasswords
} from "@foh/shared/directives/app-validators";

@Component({
  selector: 'app-guest-createprofile',
  templateUrl: './guest-createprofile.component.html',
  styleUrls: ['./guest-createprofile.component.scss']
})
export class GuestCreateprofileComponent implements OnInit {
  imageSrc: string = null;
  routeObs$: any;
  formid: any;
  form: FormGroup;
  formSubmitted = false;
  isEditMode=false;
  customer:any;
  loading:boolean;
  constructor(public reservationformService: ReservationformService,
    public activeRoute: ActivatedRoute,
    public router: Router,
    public renderer: Renderer2,
    public globals: Globals,
    public customerauthService: CustomerauthService,
    public formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createForm();
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.formid = params["token"];
      this.form.patchValue(
        {token : this.formid }
      );
      this.populateForm();
      this.reservationformService
        .retrieveMetadata(params)
        .subscribe((response: any) => {
          this.renderer.addClass(document.body, response.metaData.cssclass);
          this.imageSrc =
            this.globals.UPLOADS + "logos/" + response.metaData.logo;
        });
    });
  }

  populateForm(){

  }

  createForm(){
    this.form = this.formBuilder.group({
      fname: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2),nameValidator])
      ],
      lname: [
        "",
        Validators.compose([Validators.required, Validators.minLength(3),nameValidator])
      ],
      mobileno: [
        "",
        Validators.compose([Validators.required,phoneValidator])
      ],
      upincode: [
        "",
        Validators.compose([Validators.required])
      ],
      cupincode: [
        "",
        Validators.compose([Validators.required])
      ],
      gender: [
        "m",
        Validators.compose([])
      ],
      email: [
        "",
        Validators.compose([Validators.required,emailValidator])
      ],
      fblink: [
        "",
        Validators.compose([])
      ],
      token: ["", Validators.compose([Validators.required])],
      id: ["", Validators.compose([])]
    },
    { validator: matchingPasswords("upincode", "cupincode") });
  }

  chooseMale(){
    this.form.patchValue({
      gender : "m",
    });
  }

  chooseFemale(){
    this.form.patchValue({
      gender : "f",
    });
  }

  get f() {
    return this.form.controls;
  }

  save(){
    this.formSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    this.customerauthService.signupUser(this.form.value).subscribe(
      (response:any)=>
      {
        this.loading = false;
        if(!response.status){
          alertFunctions.error("User already exists","The mobile number is already registered, Please make sure to login or use the reset password screen to reset your password.");
          this.router.navigate(["guest/myprofile/"+this.customerauthService.getDomain()]);
          return;
        }
      },
      (error)=>
      {
        this.loading = false;
        this.customerauthService.handleHttpErrors(error);
      }
    );
  }

}
